'use strict';

var os = require('os');
var escapeStringRegexp = require('escape-string-regexp');
var extractPathRegex = /\s+at.*[(\s](.*)\)?/;
var pathRegex = /^(?:(?:(?:node|(?:(?:node:)?internal\/[\w/]*|.*node_modules\/(?:babel-polyfill|pirates)\/.*)?\w+)(?:\.js)?:\d+:\d+)|native)/;
var homeDir = typeof os.homedir === 'undefined' ? '' : os.homedir();
module.exports = function (stack) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$pretty = _ref.pretty,
    pretty = _ref$pretty === void 0 ? false : _ref$pretty,
    basePath = _ref.basePath;
  var basePathRegex = basePath && new RegExp("(at | \\()".concat(escapeStringRegexp(basePath)), 'g');
  return stack.replace(/\\/g, '/').split('\n').filter(function (line) {
    var pathMatches = line.match(extractPathRegex);
    if (pathMatches === null || !pathMatches[1]) {
      return true;
    }
    var match = pathMatches[1];

    // Electron
    if (match.includes('.app/Contents/Resources/electron.asar') || match.includes('.app/Contents/Resources/default_app.asar')) {
      return false;
    }
    return !pathRegex.test(match);
  }).filter(function (line) {
    return line.trim() !== '';
  }).map(function (line) {
    if (basePathRegex) {
      line = line.replace(basePathRegex, '$1');
    }
    if (pretty) {
      line = line.replace(extractPathRegex, function (m, p1) {
        return m.replace(p1, p1.replace(homeDir, '~'));
      });
    }
    return line;
  }).join('\n');
};